import React from 'react';

const NetBanking = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 36"
    version="1.1"
  >
    <g id="surface1">
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'var(--PRIMARY)',
          fillOpacity: 1,
        }}
        d="M 14.386719 11.011719 C 13.425781 11.011719 12.640625 11.796875 12.640625 12.757812 C 12.640625 13.71875 13.425781 14.5 14.386719 14.5 C 15.347656 14.5 16.128906 13.71875 16.128906 12.757812 C 16.128906 11.796875 15.347656 11.011719 14.386719 11.011719 Z M 14.386719 11.011719 "
      />
      <path
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fill: 'var(--PRIMARY)',
          fillOpacity: 1,
        }}
        d="M 23.535156 16.242188 C 23.652344 16.242188 23.761719 16.199219 23.84375 16.117188 C 23.925781 16.035156 23.972656 15.925781 23.972656 15.808594 L 23.972656 14.066406 C 23.972656 13.914062 23.890625 13.769531 23.757812 13.691406 L 15.234375 8.628906 L 15.222656 8.625 C 14.695312 8.328125 14.097656 8.320312 13.535156 8.628906 L 5.015625 13.691406 C 4.882812 13.769531 4.800781 13.914062 4.800781 14.066406 L 4.800781 15.808594 C 4.800781 16.050781 4.996094 16.242188 5.238281 16.242188 L 6.542969 16.242188 L 6.542969 24.085938 C 5.582031 24.085938 4.800781 24.867188 4.800781 25.828125 L 4.800781 27.136719 C 4.800781 27.378906 4.996094 27.574219 5.234375 27.574219 L 23.535156 27.574219 C 23.652344 27.574219 23.761719 27.527344 23.84375 27.445312 C 23.925781 27.363281 23.972656 27.253906 23.972656 27.136719 L 23.972656 25.828125 C 23.972656 24.867188 23.191406 24.085938 22.230469 24.085938 L 22.230469 16.242188 Z M 23.101562 25.828125 L 23.101562 26.703125 L 5.671875 26.703125 L 5.671875 25.828125 C 5.671875 25.347656 6.0625 24.957031 6.542969 24.957031 L 22.230469 24.957031 C 22.710938 24.957031 23.101562 25.347656 23.101562 25.828125 Z M 7.414062 24.089844 L 7.414062 16.242188 L 9.15625 16.242188 L 9.15625 24.089844 Z M 10.027344 24.089844 L 10.027344 16.242188 L 12.644531 16.242188 L 12.644531 24.089844 Z M 13.515625 24.089844 L 13.515625 16.242188 L 15.257812 16.242188 L 15.257812 24.089844 Z M 16.128906 24.089844 L 16.128906 16.242188 L 18.742188 16.242188 L 18.742188 24.089844 Z M 19.613281 24.089844 L 19.613281 16.242188 L 21.359375 16.242188 L 21.359375 24.089844 Z M 5.671875 15.371094 L 5.671875 14.3125 L 13.96875 9.382812 C 14.242188 9.234375 14.53125 9.234375 14.796875 9.378906 L 23.101562 14.3125 L 23.101562 15.371094 Z M 5.671875 15.371094 "
      />
    </g>
  </svg>
);

export default NetBanking;
